import styled from '@themes/theme'
import { keyframes } from '@emotion/core'

const whiteColor = '#fff'
const blackColor = '#000'
const txtColor1 = '#F5FBFE'
const txtColor2 = '#D6DBFE'
const grayColor = '#E4E6EE'
const navyColor = '#122058'
const purpleColor = '#8751FA'
const grayColor2 = '#F0F1F5'
const grayColor3 = '#EBEBEB'
const grayColor4 = '#5F6474'
const greenColor = '#00D17D'

const circlePulseAni = keyframes`
 0% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 ${purpleColor};
   opacity: .5;
 }
 70% {
   transform: translate3d(-50%, -50%, 0) scale3d(1.15, 1.15, 1.15);
   box-shadow: 0 0 0 6px ${purpleColor};
   opacity: 0;
 }
 100% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 ${purpleColor};
   opacity: 0;
 }
`
const circlePulseAni2 = keyframes`
 0% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 #FFD4B4;
   opacity: .5;
 }
 70% {
   transform: translate3d(-50%, -50%, 0) scale3d(1.15, 1.15, 1.15);
   box-shadow: 0 0 0 0 #FFD4B4;
   opacity: 0;
 }
 100% {
   transform: translate3d(-50%, -50%, 0) scale3d(0.95, 0.95, 0.95);
   box-shadow: 0 0 0 0 #FFD4B4;
   opacity: 0;
 }
`

export const FriendsInvitationWrap = styled.div`
  flex-flow: column;
  margin-top: -34px;
  .top-section {
    position: relative;
    display: flex;
    flex-flow: column;
    align-items: center;
    padding: 125% 0 30px;
    overflow: hidden;
    background-color: #7D44F7;
    &.pc {
      padding: 135% 0 30px;
    }

    .invitation-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      z-index: 0;
      &.pc {
        top: 34px;
      }
    }

    .txt {
      width: 100%;
      margin-top: 9px;
      text-align: center;
      color: ${txtColor2};
      font-weight: ${props => props.theme.fontW.medium};
      z-index: 1;
      .my-url {
        z-index: 1;
        position: relative;
        margin-left: 4px;
        color: ${txtColor1};
        &::before {
          content: '';
          display: block;
          z-index: -1;
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 100%;
          height: 9px;
          background: #9361FF;
        }
      }
    }
    .my-url-btn {
      width: calc(100% - 124px);
      height: 48px;
      margin-top: 14px;
      font-size: ${props => props.theme.font.large};
      background: #2D1561;
    }
    .my-friends {
      display: flex;
      flex-flow: column;
      align-items: center;
      margin-top: 18px;
      line-height: 27px;
      font-size: ${props => props.theme.font.largeNum};
      color: ${whiteColor};
      z-index: 1;
      .num {
        display: flex;
        justify-content: center;
        align-items: center;
        width: auto;
        height: 48px;
        margin-top: 6px;
        padding: 6px 33px;
        font-size: ${props => props.theme.font.xxlarge};
        color: ${blackColor};
        background: ${whiteColor};
        border-radius: 34px;
      }
    }
  }
  .notice {
    width: calc(100% + 1px); // 유의사항 우측 흰 배경 비치는 현상 방어
    padding: 45px 31px 140px 30px;
    background: #3C3F49;
    text-align: left;
    .tit {
      line-height: 20px;
      padding: 9px 0;
      font-size: ${props => props.theme.font.large};
      color: ${grayColor3};
      border-bottom: 1px solid ${grayColor4};
    }
    .txt {
      line-height: 15px;
      margin: 14px 0 18px;
      font-size: ${props => props.theme.font.small};
      font-weight: ${props => props.theme.fontW.medium};
      color: ${props => props.theme.color.gray};
    }
    .sub-tit {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 46px;
      height: 24px;
      margin: 9px 0;
      font-weight: ${props => props.theme.fontW.medium};
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: inherit;
        height: inherit;
        background: ${grayColor4};
        opacity: .3;
        border-radius: 4px;
      }
    }
    .notice-list {
      padding-left: 12px;
      &--item {
        position: relative;
        margin-bottom: 6px;
        line-height: 15px;
        font-size: ${props => props.theme.font.small};
        font-weight: ${props => props.theme.fontW.medium};
        color: ${props => props.theme.color.gray};
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 6px;
          left: -8px;
          width: 3px;
          height: 1px;
          background: ${props => props.theme.color.gray};
        }
      }
    }
  }
`
export const SelectMonthWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: -1px;
  padding: 42px 18px 12px;
  &:not(.no-bg) {
    background: ${whiteColor};
  }

  .prev-btn, .next-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 27px;
    transform: scale(1.5);
    &.disabled {
      opacity: .2;
    }
    .arrow {
      position: relative;
      &::before, &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        right: 0;
        background: #707070;
      }
      &::before {
        width: 10px;
        height: 1px;
      }
      &::after {
        width: 1px;
        height: 10px;
      }
    }
  }
  .prev-btn {
    .arrow {
      transform: rotate(135deg);
    }
  }
  .next-btn {
    .arrow {
      transform: rotate(-45deg);
    }
  }
  .date {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    color: ${props => props.theme.color.modalDarkBg};
    font-weight: ${props => props.theme.font.medium};
    .month {
      line-height: 30px;
      font-size: ${props => props.theme.font.xxlarge};
      color: ${blackColor};
    }
  }
  &.single-arrow {
    justify-content: center;
    .prev-btn, .next-btn {
      &.disabled {
        visibility: hidden;
      }
      .arrow {
        &::before, &::after {
          background: ${props => props.theme.color.darkTxt};
        }
      }
    }
    .date {
      margin: 0 21px;
      .month {
        color: ${props => props.theme.color.themeTxt};
      }
    }
  }
`

export const RewardListContainer = styled.div`
  position: relative;
  .reward-all-btn {
    position:absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 150px;
    max-width: 200px;
    height: 36px;
    font-size: ${props => props.theme.font.large};
    background: linear-gradient(to right, ${purpleColor}, #5210DF);
    color: ${whiteColor};
    &.pc {
      width: 200px;
      bottom: 37px;
    }
    &:disabled {
      background: ${grayColor2};
      color: #979DB6;
    }
  }
`

export const RewardListWrap = styled.div`
  padding: 133px 48px 187px;
  overflow-x: auto;
  &::-webkit-scrollbar {
    display: block !important;
  }
  &.m-reward-list-wrap {
    padding: 133px 48px 180px;
    &::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera*/
    }
  }
  .reward-list {
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;
    width: 700px;
    &--item {
      position: relative;
      width: 103px;
      min-width: 103px;
      height: 6px;
      background: ${grayColor};
      .range {
        position: absolute;
        right: 0;
        top: 19px;
        transform: translateX(50%);
        color: #22104B;
        font-weight: ${props => props.theme.fontW.medium};
        text-wrap: nowrap;
      }
      .reward-box {
        position: absolute;
        top: -94px;
        right: 0;
        transform: translateX(50%);
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        align-items: center;
        width: 82px;
        height: 76px;
        line-height: 2rem;
        padding: 11px 0;
        color: #22104B;
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
        border-radius: 9px;
        background: ${whiteColor};
        border: 2px solid #EEECF5;
        text-wrap: nowrap;
        .reward-btn {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 46px;
          height: 26px;
          color: #22104B;
          font-weight: ${props => props.theme.fontW.medium};
          background: #EEECF5;
          border-radius: 50px;
        }
        .check-ico {
          display: none;
        }
        &::before {
          content: '';
          display: block;
          position: absolute;
          bottom: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 1px;
          height: 14px;
          border-right: 1px dashed #22104B;
          opacity: .4;
        }
      }
      .gauge-bar {
        position: absolute;
        top: 0;
        left: 0;
        height: 6px;
        background: ${purpleColor};
        box-shadow: 2px 2px 10px rgba(130, 92, 255, 0.45);
      }
      .circle {
        z-index: 1;
        position: absolute;
        top: 50%;
        right: -8px;
        transform: translateY(-50%);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background: #DFDCEB;
        &::after {
          content:'';
          position: relative;
          display: block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: ${whiteColor};
        }
        .pulse-ani {
          display: none;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 18px;
          height: 18px;
          background: ${purpleColor};
          opacity: .3;
          border-radius: 50%;
          &.ani-2 {
            width: 16px;
            height: 16px;
          }
          &.ani-3 {
            width: 14px;
            height: 14px;
          }
        }
      }
      .my-gauge {
        position: absolute;
        right: 0;
        bottom: -74px;
        transform: translateX(50%);
        display: flex;
        justify-content: center;
        align-items: center;
        height: 30px;
        padding: 8px 9px 8px 12px;
        color: ${whiteColor};
        font-size: ${props => props.theme.font.large};
        background: #22104B;
        border-radius: 6px;
        &::before, &::after {
          content: '';
          display: block;
        }
        &::before {
          position: absolute;
          top: -42px;
          left: 50%;
          transform: translateX(-50%);
          width: 1px;
          height: 40px;
          background: ${grayColor};
        }
        &::after {
          position: absolute;
          top: -7px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-bottom: 8px solid ${navyColor};
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
        }
        svg {
          width: 14px;
          height: auto;
          margin-left: 4px;
        }
        .gauge-txt {
          position: absolute;
          bottom: -18px;
          left: 50%;
          transform: translateX(-50%);
          width: 92px;
          color: #22104B;
          letter-spacing: -0.5px;
          text-align: center;
        }
      }
      &:first-of-type {
        width: 41px;
        min-width: 41px;
        border-radius: 28px 0 0 28px;
        .gauge-bar {
          border-radius: 28px 0 0 28px;
        }
      }
      // 목표 달성(미수령)
      &.arrival {
        .reward-box {
          .reward-btn {
            color: ${whiteColor};
            background: linear-gradient(to right, ${purpleColor}, #5210DF);
          }
        }
        .circle {
          background: ${purpleColor};
          .pulse-ani {
            display:block;
            animation: ${circlePulseAni} 1.3s infinite ease-out;
            &.ani-2 {
              animation-delay: .2s;
            }
            &.ani-3 {
              animation-delay: .5s;
            }
          }
        }
        &:not(:last-of-type) {
          .my-gauge  {
            display: none;
          }
        }
      } /* arrival */
      // 목표 달성 + 리워드 수령 완료
      &.complete {
        .reward-box {
          background: #EEECF5;
          .reward-btn {
            display: none;
          }
          .check-ico {
            display: block;
            position: relative;
            transform: rotate(45deg) translate(-4px, -4px);
            &::before, &::after {
              content:'';
              display: block;
              position: absolute;
              bottom: 0;
              right: 0;
              background: ${greenColor};
            }
            &::before {
              width: 11px;
              height: 3px;
            }
            &::after {
              width: 3px;
              height: 18px;
            }
          }
        }
        .circle {
          background: ${purpleColor};
          .pulse-ani {
            display: none;
          }
        }
        .my-gauge  {
          display: none;
        }
      }
    }
  }
  // 마이페이지 활동점수 내 리워드
  &.activity-score {
    position: relative;
    padding: 147px 48px 58px 30px;
    .reward-list {
      &.activity-reward {
        width: 2050px;
      }
      &--item {
        background: linear-gradient(180deg, #DCDFEA, #F0F1F5);
        height: 18px;
        .range {
          top: 28px;
        }
        .reward-box {
          top: -118px;
          background: #F0F1F5;
          height: 100px;
          border: none;
          color: ${props => props.theme.color.subColor};
          font-weight: ${props => props.theme.fontW.bold};
          padding: 8px 0;
          .reward-money-img {
            width: 82px;
            height: auto;
            position: absolute;
            top: 12px;
            right: 50%;
            transform: translateX(50%);
            z-index: -1;
          }
          .reward-btn {
            width: 58px;
            height: 24px;
            background: ${props => props.theme.color.white};
            color: #12205840;
            font-weight: ${props => props.theme.fontW.bold};
          }
          &::before {
            width: 0;
            height: 0;
            bottom: -16px;
            opacity: 1;
            border-right: 6px solid transparent;
            border-left: 6px solid transparent;
            border-top: 8px solid #F0F1F5;
            border-bottom: 8px solid transparent;
          }
        }
        .gauge-bar {
          background: ${props => props.theme.color.modalOrange};
          box-shadow: 2px 2px 10px #FF945C45;
          height: 18px;
        }
        .circle {
          width: 18px;
          height: 18px;
          background: #D1D4DF;
          .pulse-ani {
            width: 28px;
            height: 28px;
            background: #FFD4B450;
          }
          &::after {
            width: 8px;
            height: 8px;
          }
        }

        // 목표 달성(미수령)
        &.arrival {
          .reward-box {
            background: linear-gradient(160deg, #E84D08, #FE9800);
            box-shadow: inset 1px 1px 1px #FFFBC540, 0 2px 6px #00000020;
            color: ${props => props.theme.color.white};
            .reward-btn {
              color: ${props => props.theme.color.modalTxt};
              background: linear-gradient(180deg, #FFFDE5, #FFEEBF);
            }
            &::before {
              border-top: 8px solid #FE9800;
            }
          }
          .circle {
            background: #F8964D;
            // background: ${props => props.theme.color.modalOrange};
            .pulse-ani {
              animation: ${circlePulseAni2} 1.3s infinite ease-out;
            }
            ::before{
              content: '';
              display: block;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 18px;
              height: 18px;
              border-radius: 50%;
              background: ${props => props.theme.color.modalOrange};
              z-index: 1;
            }
            &::after {
              z-index: 2;
            }
            &.complete {
              ::before{
                background: transparent;
              }
            }
          }
        }
        // 목표 달성 + 리워드 수령 완료
        &.complete {
          .reward-box {
            background: #F0F1F5;
            color: #99A7B760;
            box-shadow: none;
            &::before {
              border-top: 8px solid #F0F1F5;
            }
          }
        }
      }
    }

  }
`
export const FriendsListWrap = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 42px 0 0;
  background: #EEECF5;
  .tit {
    line-height: 27px;
    color: #22104B;
    font-size: ${props => props.theme.font.largeNum};
    font-weight: ${props => props.theme.fontW.medium};
    margin-bottom: 5px;
  }
  .number {
    line-height: 27px;
    color: #22104B;
    font-size: ${props => props.theme.font.xxlarge};
    .total {
      color: #AAA2BC;
      font-weight: ${props => props.theme.fontW.medium};
      opacity: .8;
    }
  }
  .friends-list {
    width: 100%;
    margin-top: 24px;
    //padding: 0 30px;
    &::-webkit-scrollbar {
      display: block !important;
    }
    .am-list-body {
      background: none;
    }
    &--item {
      position: relative;
      display: flex;
      align-items: center;
      padding: 14px 30px;
      &:not(:last-of-type) {
        border-bottom: 1px solid #E7E8EE;
      }
      .new-badge {
        position: absolute;
        top: 7px;
        left: 17px;
        width: 10px;
        height: 10px;
      }
      .nick {
        width: 120px;
        color: #22104B;
        font-size: ${props => props.theme.font.large};
        font-weight: ${props => props.theme.fontW.medium};
      }
      .bar-chart {
        flex: 1;
        display: inline-flex;
        align-items: center;
        .bar {
          min-width: 1px;
          height: 10px;
          background: ${purpleColor};
          border-radius: 0 5px 5px 0;
        }
        .value {
          margin-left: 6px;
          color: #AAA2BC;
          font-weight: ${props => props.theme.fontW.medium};
        }
      }
      // 베팅 안한 유저
      &.no-bet {
        .nick {
          opacity: .2;
        }
        .bar-chart {
          .bar {
            opacity: .1;
          }
        }
      }
    }
    &.pc {
      height: 470px;
      &.blank {
        height: 0;
      }
    }
  }
  // 베팅한 친구가 없을 경우
  .no-friends-txt {
    margin-top: 21px;
    padding-bottom: 60px;
    color: #AAA2BC;
    font-size: ${props => props.theme.font.large};
    font-weight: ${props => props.theme.fontW.medium};
  }
`
